import { catchError, map, Observable, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LocationDTO } from '../../../../dto/location/location.dto';
import { Location } from '../../../../models/location/Location.model';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { FunctionRegistryService } from '../../../../services/function-registry/function-registry.service';
import { environment } from '../../../../environment/environment';

export function locations_suggested(componentDataSourceService: ComponentDataSourceService) {
    return {
      name: 'Suggested Locations',
      description: 'List of suggested locations based on user preferences',
      execute: (params?: LoadDataParams) => {
        
        return componentDataSourceService.http.get<any>(
          `${environment.apiUrl}/locations/suggested`,
          params?.queryParams ? { params: params.queryParams } : {}
        ).pipe(
          catchError(error => {
            console.error('Error fetching suggested locations:', error);
            return of({ items: [], totalCount: 0 });
          }),
          map(result => {
            if (result && result.items) {
              try {
                const locations = result.items.map((location: any) => {
                  const locationDTO: LocationDTO = {
                    guid: location.guid,
                    locations_name: location.locations_name,
                    clean_name: location.clean_name,
                    data: location.data || {},
                    rooms: location.rooms || [],
                    users: location.users || [],
                    registered_percentage: location.registered_percentage || 0,
                    progress_percentage: location.progress_percentage || 0,
                    ok_percentage: location.ok_percentage || 0,
                    firefighter_count: location.firefighter_count || 0
                  };
                  
                  return Location.fromDTO(locationDTO);
                });

                return {
                  items: locations,
                  totalCount: result.totalCount,
                  pageSize: result.pageSize,
                  pageIndex: result.pageIndex
                };
              } catch (error) {
                console.error('Error converting DTO to Location:', error);
                return { items: [], totalCount: 0 };
              }
            } else {
              throw new Error('No suggested locations found');
            }
          })
        );
      },
      settings: {
        columns: [
          { key: 'locations_name', header: 'Navn', type: 'text' },
          {
            key: 'actions',
            header: '',
            type: 'button',
            buttonText: 'Tilføj',
            buttonColor: 'primary',
            variant: 'raised',
            action: (item: Location) => {
              componentDataSourceService.functionRegistryService.executeFunction('openModal', 'add_location', { data: item });
            }
          }
        ],
        pageable: true,
        sortable: true,
        rowHover: true,
        searchable: true,
        defaultSortColumn: 'name',
        defaultSortDirection: 'asc'
      }
    }
} 